import { render, staticRenderFns } from "./tupoksi.vue?vue&type=template&id=29e69f70&"
import script from "./tupoksi.vue?vue&type=script&lang=js&"
export * from "./tupoksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports